'use client';

import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';

export default function FormSuccessMessage({ className, id }: { className?: string; id?: string }) {
    const t = useTranslations();

    return (
        <div
            className={cn(
                'flex flex-col items-center justify-center text-center max-lg:py-12 max-lg:px-4 max-lg:gap-8 max-lg:bg-white/80 max-lg:backdrop-blur-sm lg:p-[120px] lg:gap-[60px] bg-white/70 shadow-m backdrop-blur-[15px] relative z-10',
                className,
            )}
            id={id}
            role="status"
            aria-live="polite"
        >
            <h3 className="w-full text-dark-grey leading-normal text-h1 max-lg:text-h2">
                {t.rich('Form.submissionSuccessTitle', {
                    strong: (chunks) => <span className="text-brand">{chunks}</span>,
                })}
            </h3>
            <div className="w-full border-t border-dark-grey" />
            <p className="w-full text-dark-grey font-medium leading-normal text-h4 max-lg:text-h5">
                {t('Form.submissionSuccessDetails')}
            </p>
        </div>
    );
}
